export const formatCurrency = (value?: number | string) => {
    if (value === undefined) return '';
    if (typeof value === 'string') value = Number(value);
    const formatted = value.toFixed(2).replace('.', ',');
    return `R$${formatted}`;
};
